// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeDCard_wrapper__2ap6V"};